import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';
import { appendTrackingParams } from '../../utils/utm';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="bg-ev-ink text-white" data-testid="footer">
      {/* Big CTA panel */}
      <section className="py-24 md:py-32 px-6 md:px-10 border-t border-white/5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-[1100px] mx-auto text-center">
          <p className="font-body text-[10px] uppercase tracking-[0.4em] text-ev-lime mb-6">{t.foot_cta_label}</p>
          <h2
            className="font-display font-light lowercase mb-10"
            style={{ fontSize: 'clamp(2.5rem, 7vw, 6rem)', letterSpacing: '-0.04em' }}>
            {t.foot_h}
          </h2>
          <a
            href={appendTrackingParams(t.foot_cta_url)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-10 py-4 bg-ev-lime hover:bg-ev-lime-dim text-ev-ink font-body font-medium text-base rounded-full transition-colors lowercase"
            data-testid="footer-cta">
            {t.foot_cta}
          </a>
        </motion.div>
      </section>

      {/* Footer bar */}
      <div className="border-t border-white/10 py-10 px-6 md:px-10">
        <div className="max-w-[1500px] mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <img src="/assets/evern-logo.png" alt="evern" className="h-5 w-auto mb-3" />
            <p className="font-body text-xs text-white/40 leading-relaxed mt-3 max-w-[360px]">{t.foot_address}</p>
            <div className="flex flex-col md:flex-row md:items-center md:gap-4 mt-2">
              <a href={`mailto:${t.foot_email}`} className="font-body text-xs text-white/60 hover:text-white transition-colors" data-testid="footer-email">{t.foot_email}</a>
              <a href={t.foot_website_url} target="_blank" rel="noopener noreferrer" className="font-body text-xs text-white/60 hover:text-white transition-colors" data-testid="footer-website">{t.foot_website}</a>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 md:justify-end">
            <Link to="/activation" className="font-body text-xs text-white/60 hover:text-white transition-colors" data-testid="footer-activation-link">{t.foot_activation}</Link>
            {t.foot_links.map((link, i) => (
              <Link key={i} to={link.to} className="font-body text-xs text-white/40 hover:text-white transition-colors" data-testid={`footer-link-${i}`}>{link.label}</Link>
            ))}
            <span className="font-body text-xs text-white/30">{t.foot_copy}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
